module.exports = require('./helpers/bundle-url').getBundleURL('eiBOl') + "logo-dark.eefe0b7f.svg";